export default function validationFacture(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;

    if (message.indexOf('MANUAL_SETTLE_NO_ASSETS') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.pasAvoir',
        parametres: {
          qte: splitMessage[1],
        },
      });
    }
    if (message.indexOf('MANUAL_SETTLE_NO_CANCEL') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.pasEtatAnnule',
        parametres: {
          qte: splitMessage[1],
        },
      });
    }
    if (message.indexOf('MANUAL_SETTLE_NO_DRAFT') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.pasEtatBrouillon',
        parametres: {
          qte: splitMessage[1],
        },
      });
    }
    if (message.indexOf('MANUAL_SETTLE_ONLY_BILLS') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.pasFacture',
        parametres: {
          qte: splitMessage[1],
        },
      });
    }
    if (message.indexOf('MANUAL_SETTLE_ONLY_SALE') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.pasVentes',
        parametres: {
          qte: splitMessage[1],
        },
      });
    }
    if (message.indexOf('MANUAL_SETTLE_BILLS_WITHOUT_AMOUNT_TO_SETTLE') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.pasDeSolde',
        parametres: {
          code: splitMessage[1],
        },
      });
    }
    if (message.indexOf('FACTURE_PAID_STATE_REQUIRED') === 0) {
      messages.push({
        message: 'detailFacture.messages.error.pasPaye',
      });
    }
    if (message.indexOf('FACTURE_LITERATE_CUSTOMER_MOUVEMENT_REQUIRED') === 0) {
      messages.push({
        message: 'detailFacture.messages.error.mvtClientPastTousLettre',
      });
    }
    if (message.indexOf('ECHEANCES_FACTURE_NOT_LETTERED_WITH_SAME_MOVEMENT_OD') === 0) {
      messages.push({
        message: 'detailFacture.messages.error.mvtClientPasLettreAvecMemeOD',
      });
    }
  });
}
